export default {
      id: "child-care-benefit-icon-usage",
      viewBox: "0 0 200 60",
      url: __webpack_public_path__ + "sprite.svg#child-care-benefit-icon",
      toString: function () {
        return this.url;
      }
    }